export interface RequestActionTypes {
    start: string
    startWithoutSnackbar: string
    success: string
    successWithoutSnackbar: string
    error: string
}

export const createRequestActionTypes = (requestName: string): RequestActionTypes => ({
    start: `${requestName}_REQUEST_START`,
    startWithoutSnackbar: `${requestName}_WITHOUT_SNACKBAR_START`,
    success: `${requestName}_REQUEST_SUCCESS`,
    error: `${requestName}_REQUEST_ERROR`,
    successWithoutSnackbar: `${requestName}_WITHOUT_SNACKBAR_SUCCESS`,
})